import { Component, computed, input } from '@angular/core';
import { Ticket } from 'src/app/models/ticket/ticket.model';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

@Component({
  selector: 'app-ticket-detail-header',
  templateUrl: './ticket-detail-header.component.html',
  standalone: false,
})
export class TicketDetailHeaderComponent {
  readonly ticket = input.required<Ticket>();

  readonly title = computed(() => {
    const t = this.ticket();
    if (t.Subject) {
      return t.Subject;
    }
    if (t.Portal_Ticket_Type__c) {
      return t.Portal_Ticket_Type__c.replace(/\w\S*/g, (w) =>
        w[0].toUpperCase() + w.slice(1).toLowerCase(),
      );
    }
    return 'No title available';
  });

  readonly statusLabel = computed(() =>
    this.ticket().IsClosed ? 'Closed' : 'Open',
  );

  readonly statusBadgeClass = computed(() =>
    this.ticket().IsClosed
      ? 'comcast-status-pill--success'
      : 'comcast-status-pill--danger',
  );

  readonly statusDateLabel = computed(() => {
    const t = this.ticket();
    const date = t.IsClosed ? t.ClosedDate : t.CreatedDate;
    const action = t.IsClosed ? 'Closed' : 'Opened';
    return date
      ? `${action} ${dateFormatter.format(new Date(date)).replace(',', ' ·')}`
      : `${action} date unavailable`;
  });
}
